var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"r-block",class:[
    {
      row: _vm.row,
      col: _vm.col,
      rtl: _vm.rtl,
      ovh: _vm.ovh,
      start: _vm.start,
      center: _vm.center,
      bottom: _vm.bottom,
      top: _vm.top,
      scroll: _vm.scroll,
      radius: _vm.radius,
      stretch: _vm.stretch,
      disabled: _vm.disabled,
      noPadding: _vm.noPadding,
      bottomSpace: _vm.bottomSpace,
      spaceBetween: _vm.spaceBetween
    },
    _vm.borderClass,
    _vm.bgClass
  ],style:(_vm.style)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }